import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import DahliasShell from "../../components/dahlias/DahliasShell";

const EFFECTIVE = "15 February 2026";

export function LegalLayout({ eyebrow, title, children, testid }) {
  return (
    <DahliasShell>
      <section
        data-testid={testid}
        className="max-w-3xl mx-auto px-5 md:px-8 py-12 md:py-20"
      >
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-label tracking-[0.3em] text-xs text-[var(--dahlias-ink)]/65 hover:text-[var(--berry)] transition mb-6"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> BACK HOME
        </Link>

        <div className="text-center">
          <span className="font-label tracking-[0.4em] text-[11px] text-[var(--berry)]">
            {eyebrow}
          </span>
          <h1 className="mt-3 font-display text-4xl md:text-5xl text-[var(--dahlias-forest)] leading-[1.05]">
            {title}
          </h1>
          <p className="mt-3 text-xs uppercase tracking-[0.3em] text-[var(--dahlias-ink)]/55">
            Effective {EFFECTIVE}
          </p>
        </div>

        <article className="legal-prose mt-10 bg-[var(--dahlias-paper)] border-[3px] border-[var(--berry)]/25 wobble-a p-6 md:p-10 text-[15px] leading-relaxed text-[var(--dahlias-ink)]/85">
          {children}
        </article>

        <div className="mt-8 flex gap-2 flex-wrap justify-center text-xs">
          <FooterLink to="/legal/subscription-terms">Subscription Terms</FooterLink>
          <FooterLink to="/legal/grower-terms">Grower Terms</FooterLink>
          <FooterLink to="/legal/privacy">Privacy Policy</FooterLink>
          <FooterLink to="/legal/terms-of-use">Website Terms of Use</FooterLink>
        </div>
      </section>
    </DahliasShell>
  );
}

function FooterLink({ to, children }) {
  return (
    <Link
      to={to}
      className="px-3 h-8 inline-flex items-center wobble-pill text-[var(--dahlias-ink)]/65 hover:text-[var(--berry)] hover:bg-[var(--berry)]/10 transition"
    >
      {children}
    </Link>
  );
}

export function H2({ children, n }) {
  return (
    <h2 className="mt-8 font-display text-2xl md:text-3xl text-[var(--dahlias-forest)] leading-tight first:mt-0">
      <span className="text-[var(--berry)] font-display-italic">{n}.</span> {children}
    </h2>
  );
}

export function P({ children }) {
  return <p className="mt-3">{children}</p>;
}

export function UL({ children }) {
  return <ul className="mt-3 ml-5 list-disc space-y-1 marker:text-[var(--berry)]">{children}</ul>;
}
